  <template>
    <svg xmlns="http://www.w3.org/2000/svg" width="83" height="83" viewBox="0 0 83 83" style="padding: 1.75em;">
      <g id="Group_18" data-name="Group 18" transform="translate(-595 -592)">
        <g id="Group_16" data-name="Group 16" transform="translate(-194 -59)">
          <g id="Group_13" data-name="Group 13" transform="translate(789 651)">
            <g id="wooden-box" transform="translate(0 0)">
              <path id="Path_24" data-name="Path 24" d="M24.194,10.375H66.347L76.722,0H1.061L11.436,10.375Z" transform="translate(2.608)" fill="#e69117" />
              <path id="Path_27" data-name="Path 27" d="M10.375,11.438,0,1.06V76.728L10.375,66.35Z" transform="translate(0 2.606)" fill="#e69117" />
              <path id="Path_29" data-name="Path 29" d="M21,11.438V66.35L31.375,76.728V1.06Z" transform="translate(51.625 2.606)" fill="#e69117" />
              <path id="Path_30" data-name="Path 30" d="M53.59,21H11.436L1.061,31.375H76.722L66.347,21Z" transform="translate(2.608 51.625)" fill="#e69117" />
            </g>
          </g>
          <g id="wooden-storage-crate" transform="translate(804.624 666.624)">
            <g id="Group_15" data-name="Group 15">
              <path id="Path_31" data-name="Path 31" d="M71.634,0H83.542L71.634,11.907Z" transform="translate(-52.302)" fill="#e69117" />
              <path id="Path_32" data-name="Path 32" d="M0,0H12.2V19.043L0,31.239Z" fill="#e69117" />
              <path id="Path_33" data-name="Path 33" d="M8.815,51.753H0V41.335l12.2-12.2L19.332,22,32.42,8.915l7.137-7.138L41.333,0h10.42V8.816L39.557,21.01,32.42,28.148,19.332,41.236,12.2,48.374Z" fill="#e69117" />
              <path id="Path_34" data-name="Path 34" d="M84.722,155.222H71.634V154.8l13.088-13.084Z" transform="translate(-52.302 -103.469)" fill="#e69117" />
              <path id="Path_35" data-name="Path 35" d="M158.773,102.913h-12.2V82.264l12.2-12.194Z" transform="translate(-107.02 -51.16)" fill="#e69117" />
            </g>
          </g>
        </g>
      </g>
    </svg>

  </template>
  <script>
    export default {
      name: "Logo",
      components: {},
      props: {
        size: {
          type: String,
          default: "70%",
        },
      },
    };
  </script>